import { render, staticRenderFns } from "./associateItem.vue?vue&type=template&id=8309adf8&scoped=true&"
import script from "./associateItem.vue?vue&type=script&lang=js&"
export * from "./associateItem.vue?vue&type=script&lang=js&"
import style0 from "./associateItem.vue?vue&type=style&index=0&id=8309adf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8309adf8",
  null
  
)

export default component.exports